var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2174 5.21744C15.5892 4.59357 15.0019 4.01057 14.4146 3.42542C13.7025 2.71119 12.9862 1.99912 12.2762 1.28274C12.0224 1.02674 11.9794 0.667473 12.1472 0.379201C12.3193 0.084475 12.6613 -0.0725688 12.9883 0.0328441C13.1346 0.0801724 13.2766 0.17698 13.3863 0.286696C14.5544 1.44409 15.714 2.61008 16.8778 3.77393C17.1704 4.0665 17.4673 4.35693 17.7556 4.65595C18.0825 4.99586 18.0825 5.42826 17.7491 5.76171C16.2712 7.24395 14.7932 8.72403 13.311 10.1998C12.984 10.5268 12.5215 10.529 12.2181 10.2213C11.917 9.91369 11.9256 9.46192 12.2569 9.12847C13.5175 7.86352 14.7825 6.60502 16.0453 5.34436C16.0883 5.30134 16.1442 5.27122 16.2174 5.21744Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78261 5.21744C2.41079 4.59357 2.99809 4.01057 3.58539 3.42542C4.29746 2.71119 5.01384 1.99912 5.72377 1.28274C5.97762 1.02674 6.02064 0.667473 5.85284 0.379201C5.68074 0.084475 5.33869 -0.0725688 5.01169 0.0328441C4.8654 0.0801724 4.72342 0.17698 4.6137 0.286696C3.44556 1.44409 2.28601 2.61008 1.12217 3.77393C0.829595 4.0665 0.532718 4.35693 0.244446 4.65595C-0.0825496 4.99586 -0.0825496 5.42826 0.2509 5.76171C1.72883 7.24395 3.20676 8.72403 4.689 10.1998C5.01599 10.5268 5.47852 10.529 5.78185 10.2213C6.08303 9.91369 6.07443 9.46192 5.74313 9.12847C4.48247 7.86352 3.21752 6.60502 1.95472 5.34436C1.91169 5.30134 1.85576 5.27122 1.78261 5.21744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrow);
export default __webpack_public_path__ + "static/media/nav_arrow.cb51b81d15fe3763a88d0e094a9d62af.svg";
export { ForwardRef as ReactComponent };